const uberV2 = {
  voucherDueDateTitle: 'Son ödeme tarihi',
};

module.exports = uberV2;
